import axios from 'axios';
import { formatFecha } from '../hooks/useFetchData';
import { useParams } from 'react-router-dom';


const bearerToken = process.env.REACT_APP_BEARER_TOKEN;

const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

export const capitalizeWords = (string) => {
    return string
    .split(" ")
    .map(word => capitalize(word))
    .join(" ");
};

export const getDynamicIds = () => {
    const path = window.location.pathname; 
    const match = path.match(/^\/(\w+)-(\w+)/); 
    
    if (match) {
        const [, cadena, pais] = match;

        const paisIds = { cl: 2 , ec: 4 , co: 3 , pe :1};
        const cadenaIds = { gmo: 1, eco: 2, opv: 5 };

        const paisId = paisIds[pais] || null;
        const cadenaId = cadenaIds[cadena] || null;

        return { paisId, cadenaId };
    }

    return { paisId: null, cadenaId: null };
};

const { paisId, cadenaId } = getDynamicIds();

const fetchData = async (url, params = {}) => {
    try {
        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${bearerToken}`
            },
            params
        });
        return response.data;
    } catch (error) {
        // Error general al obtener datos desde la API
        console.error(`Error fetching data from ${url}:`, error);
        throw error;
    }
};

export const getPaises = () => fetchData(`${process.env.REACT_APP_API_URL_PAISES}`);

export const getProfesiones = () => {
    return fetchData(`${process.env.REACT_APP_API_URL_PROFESIONES}`)
        .then(response => response.map(profesion => ({
            prf_codigo: profesion.prf_codigo,
            prf_denominacion: profesion.prf_denominacion
        })))
        .catch(error => {
            // Error al obtener profesiones desde la API
            console.error('Error fetching profesiones:', error);
            return [];
        });
};

export const getFormularioAnamnesis = (interesadoId) => {
    return fetchData(`${process.env.REACT_APP_API_URL_FORMULARIOANAMNESIS}`, {
        interesadoId: interesadoId
    })
    .then(response => {
        // Verifica si response.data[0] está definido y contiene el array que esperas
        if (response && response.data && response.data[0] && Array.isArray(response.data[0].detalle)) {
            return response.data[0].detalle.map(anamnesis => ({
                det_codigo: anamnesis.det_codigo,
                det_descripcion: anamnesis.det_descripcion,
                alternativa: anamnesis.alternativa
            }));
        } else {
            console.error('La respuesta no contiene el formato esperado:', response);
            return [];
        }
    })
    .catch(error => {
        console.error('Error fetching formulario anamnesis:', error);
        return [];
    });
};

export const getCadenas = (selectedPais) => 
    fetchData(`${process.env.REACT_APP_API_URL_CADENAS}/${selectedPais}`)
    .then(data => Object.entries(data).map(([key, value]) => ({
        cda_codigo: key,
        cda_descripcion: value
    })));

export const getRegiones = (selectedPais, selectedCadena) => 
    fetchData(`${process.env.REACT_APP_API_URL_REGIONES}/${selectedPais}/${selectedCadena}`)
    .then(data => Object.entries(data).map(([key, value]) => ({
        dpt_codigo: key,
        dpt_descripcion: value
    })));

export const getProvincias = (selectedRegion, selectedCadena) =>
    fetchData(`${process.env.REACT_APP_API_URL_PROVINCIAS}/${selectedRegion}/${selectedCadena}`)
    .then(data => Object.entries(data).map(([key, value]) => ({
        prv_codigo: key,
        prv_descripcion: value
    })));

export const getComunas = (selectedProvincia, selectedCadena) => 
    fetchData(`${process.env.REACT_APP_API_URL_COMUNAS}/${selectedProvincia}/${selectedCadena}`)
    .then(data => Object.entries(data).map(([key, value]) => ({
        ubg_codigo: key,
        ubg_denominacion: value
    })));

export const getTiendas = (selectedComuna, selectedCadena) => 
    fetchData(`${process.env.REACT_APP_API_URL_TIENDAS}/${selectedComuna}/${selectedCadena}`);

export const getServicios = (selectedTienda) => 
    fetchData(`${process.env.REACT_APP_API_URL_SERVICIOS}/${selectedTienda}`);

export const getHorarios = (selectedTienda, selectedServicio, selectedDate) => {
    const formattedDate = formatFecha(selectedDate);
    return fetchData(`${process.env.REACT_APP_API_URL_HORARIOS}`, {
        tiendaId: selectedTienda,
        servicioId: selectedServicio,
        fecha: formattedDate
    }).then(response => {
        const data = response.data[0].turno;
        return data.map(turno => ({
            codigoTurno: turno.trn_codigo,
            turnoDescripcion: turno.trn_descripcion
        }));
    });
};

export const getHoras = (selectedTienda, selectedServicio, selectedHorarios, selectedDate) => {
    const formattedDate = formatFecha(selectedDate);
    
    return fetchData(`${process.env.REACT_APP_API_URL_HORAS}`, {
      tiendaId: selectedTienda,
      servicioId: selectedServicio,
      horarioId: selectedHorarios,
      fecha: selectedDate
    }).then(data => {
      // Mapeamos los datos de la respuesta
      const horas = data.map(hora => ({
        hora: hora.htr_hora
      }));
      
      // Hacemos un console.log de la respuesta limpia
    //   console.log("Respuesta limpia de horas: ", horas);
      
      return horas; // Devolvemos las horas mapeadas
    });
  };
  

export const getDocumentTypes = (selectedPais) =>
    fetchData(`${process.env.REACT_APP_API_URL_DOCUMENTOS}/${selectedPais}`)
    .then(data => Object.entries(data).map(([key, value]) => ({
        tpo_codigo: key,
        tpo_descripcion: value
    })));

    export const getTodasLasTiendas = (busquedatienda) => {
        return fetchData(`${process.env.REACT_APP_API_URL_TODASLASTIENDAS}`, {
            nombreComuna: busquedatienda
        }).then(data => {
            // Mostrar el objeto completo recibido
            // console.log("Datos completos recibidos:", data);
    
            // Continuar con el mapeo de los datos
            return data.map(tienda => ({
                cda_descripcion: tienda.cda_descripcion,
                descripcion: tienda.descripcion,
                direccion: tienda.direccion,
                ubicacion: tienda.ubg_denominacion,
                cfg_codigo: tienda.cfg_codigo,
                servicios: tienda.servicios,
                cfg_latitud: tienda.cfg_latitud,
                cfg_longitud: tienda.cfg_longitud
            }));
        });
    };
export const getDatosReserva = async (dni, id_reserva) => {
    // console.log(dni , id_reserva)
    const url = `${process.env.REACT_APP_API_URL_GETRESERVAS}`;
    const params = {
      dni,
      id_reserva,
    };
  
    try {
      const data = await fetchData(url, params); // Usa fetchData con los parámetros
      return data; // Devuelve los datos obtenidos
    } catch (error) {
      console.error("Error al obtener los datos de reserva:", error);
      throw error; // Lanza el error para manejarlo en el componente
    }
  };

  export const getTodasLasTiendasConServicios = (busquedatienda) => {
    if (!paisId || !cadenaId) {
        console.error("Error: No se pudo determinar paisId o cadenaId desde la URL.");
        return Promise.resolve([]);
    }

    return fetchData(`${process.env.REACT_APP_API_URL_TODASLASTIENDAS}`, {
        paisId,
        cadenaId,
        nombreComuna: busquedatienda
    }).then(data => {
        // console.log("Datos completos recibidos:", data);
        return data;
    });
};

export const getConvenios = () => {
    if (!paisId || !cadenaId) {
        console.error("Error: No se pudo determinar paisId o cadenaId desde la URL.");
        return Promise.resolve([]);
    }

    return fetchData(`${process.env.REACT_APP_API_URL_CONVENIOCADENA}`, {
        paisId,
        cadenaId,
    }).then(data => {
        // console.log("Datos de convenios", data);
        return data;
    });
};
